import { PaginationType } from 'common';
import { PropertiesActionType } from 'enums';
import { PropertyType, UploadCsvType } from 'state';

export const setProperties = (properties: PropertyType[]) =>
  ({ type: PropertiesActionType.SET_PROPERTIES, properties } as const);

export const setPropertiesAfterScroll = (properties: PropertyType[]) =>
  ({ type: PropertiesActionType.SET_PROPERTIES_AFTER_SCROLL, properties } as const);

export const searchProperties = (search: string) =>
  ({ type: PropertiesActionType.SEARCH_PROPERTIES, search } as const);

export const setPropertiesPagination = (pagination: PaginationType) =>
  ({ type: PropertiesActionType.SET_PROPERTIES_PAGINATION, pagination } as const);

export const setCertainProperty = (property: PropertyType) =>
  ({ type: PropertiesActionType.SET_CERTAIN_PROPERTY, property } as const);

export const setPropertiesLoadingStatus = (isLoading: boolean) =>
  ({ type: PropertiesActionType.SET_PROPERTIES_LOADING_STATUS, isLoading } as const);

export const setUploadedCsv = (uploadedCsv: UploadCsvType[]) =>
  ({ type: PropertiesActionType.SET_UPLOADED_CSV, uploadedCsv } as const);
